import store from "@/store";

export default function checkAccountCompletion({ next, router }) {
  const accountType = store.getters["user/getAccountType"];

  if (accountType === "doctor") {
    return checkDoctorProfileCompletion(router, next);
  } else if (accountType === "clinic") {
    return checkClinicProfileCompletion(router, next);
  }

  return next();
}

const checkDoctorProfileCompletion = (router, next) => {
  const accountCompletion = store.getters["accountCompletion/completion"];

  if (!accountCompletion?.sms_verified) {
    return router.push({ name: "DoctorVerifyPhoneNumber" });
  }
  if (!accountCompletion?.complete_clinic_name) {
    return router.push({ name: "DoctorChooseOfficeName" });
  }
  if (!accountCompletion?.complete_choose_user_services) {
    return router.push({ name: "DoctorServices" });
  }
  if (!accountCompletion?.complete_set_calendar_schedule) {
    return router.push({ name: "DoctorWorkingHours" });
  }
  if (!accountCompletion?.complete_choose_facility) {
    return router.push({ name: "AuthFalicityDoctor" });
  }

  return next();
};

const checkClinicProfileCompletion = (router, next) => {
  const accountCompletion = store.getters["accountCompletion/completion"];

  if (!accountCompletion?.sms_verified) {
    return router.push({ name: "ClinicVerifyPhoneNumber" });
  }
  if (!accountCompletion?.complete_clinic_name) {
    return router.push({ name: "ClinicChooseOfficeName" });
  }
  if (!accountCompletion?.complete_clinic_services) {
    return router.push({ name: "ClinicServices" });
  }

  return next();
};
